import { render, staticRenderFns } from "./berita-acara.vue?vue&type=template&id=5d97833c&"
import script from "./berita-acara.vue?vue&type=script&lang=js&"
export * from "./berita-acara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports